import {createFileRoute} from '@tanstack/react-router';
import {grantUser, viewDiagnosticReportGranted} from '@/practitioner/routing/utils/beforeLoadUtils';
import ImageProtocolDetail from '@/practitioner/views/imageProtocol/ImageProtocolDetail';

export const Route = createFileRoute(
  '/(practitioner)/patients/$patientId/image-protocols/$imageProtocolId'
)({
  component: ImageProtocolDetail,
  beforeLoad: grantUser(viewDiagnosticReportGranted),
  loader: ({params}) => ({
    patientId: params.patientId,
    imageProtocolId: params.imageProtocolId
  })
});
